export default __webpack_public_path__ + "static/media/logoDelta.113ddc78.png";